import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Alert } from 'rsuite';
import { generateReport, saveEditedReport, setGenerateReportData } from '../../../../../actions/actionsModuloRelatorio';

import { dimensionsSelectionMissingText, moduleReportEnumsType, moduleReportReverseEnumsType } from '../utils';

export const useGenerateReport = () => {
  const [consolidateSelectedList, setConsolidateSelectedList] = useState([]);
  const { consolidadoData, moduloRelatorioData } = useSelector(
    state => ({
      consolidadoData: state.moduloRelatorioDataReducer?.consolidadoData,
      moduloRelatorioData: state.moduloRelatorioDataReducer?.moduloRelatorioData,
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();

  const { id } = useParams();

  const validateConsolidadoData = type => {
    const productValidatedList = moduloRelatorioData.produto.filter(product => product.length <= 14);

    const hasRequiredDimensions =
      consolidadoData.produto.length > 0 &&
      consolidadoData.local.length > 0 &&
      (consolidadoData.preco.length > 0 || consolidadoData.quantidade.length > 0 || consolidadoData.comFiltro.length > 0);

    if (!hasRequiredDimensions) {
      Alert.warning(dimensionsSelectionMissingText, 5000);
      return;
    }

    const generateDataBody = {
      ...moduloRelatorioData,
      recorrencia: false,
      relatorioSalvo: false,
      produto: productValidatedList,
    };

    const editedDataBody = {
      ...moduloRelatorioData,
      produto: productValidatedList,
    };

    const action = type === 'generate' ? generateReport(generateDataBody) : saveEditedReport(id, editedDataBody);

    dispatch(action);
  };

  const setDimensoesList = () => {
    const allList = [];
    const dimensoes = [...moduloRelatorioData.dimensoes];
    const hasItem = moduloRelatorioData.dimensoes.length > 0;

    const dimensoesSelectedList = allList
      .concat(consolidadoData.produto, consolidadoData.local, consolidadoData.preco, consolidadoData.quantidade, consolidadoData.comFiltro)
      .filter(item => item.column === '2')
      .map(item => ({
        dimensao: {
          name: moduleReportEnumsType[item.name],
        },
        consolidado: false,
      }));

    const prevConsolidado = dimensoes.filter(item => item.consolidado === true);

    const activeConsolidado = prevConsolidado.filter(item => dimensoesSelectedList.some(i => item.dimensao.name === i.dimensao.name));

    const consolidadoActiveFilterList = activeConsolidado.map(item => moduleReportReverseEnumsType[item.dimensao.name]);

    const filteredList =
      hasItem && activeConsolidado.length
        ? dimensoesSelectedList.filter(item => !activeConsolidado.some(i => item.dimensao.name === i.dimensao.name))
        : dimensoesSelectedList;

    const concatLists = filteredList.concat(activeConsolidado);

    dispatch(setGenerateReportData('dimensoes', concatLists));
    setConsolidateSelectedList(consolidadoActiveFilterList);
  };

  return {
    setDimensoesList,
    validateConsolidadoData,
    consolidateSelectedList,
    setConsolidateSelectedList,
  };
};
